import { Urls } from '../../../Shared/Api';

export default class ReviewsCarouselService {
    static getReviews() {
        return fetch(Urls.reviews.getReputationData)
            .then((res) => {
                return res.json();
            });
    }
}


// WEBPACK FOOTER //
// ./Src/Components/Reputation/ReputationCarousel/ReputationCarouselService.js